/**
 * Firebase initialisation.
 *
 * In demo mode (`REACT_APP_DEMO=true`) this module exports null stubs so that
 * no Firebase code runs, no network requests fire, and no configuration is
 * required. Import guards on `IS_DEMO` at every call site reinforce this, but
 * the null exports are the structural guarantee.
 */
import { IS_DEMO } from './demoData';
import { FIREBASE_CONFIG, isFirebaseConfigured } from './config';

let app = null;
let auth = null;

if (!IS_DEMO && isFirebaseConfigured) {
    // Dynamic require keeps Firebase out of the demo bundle entirely when
    // tree-shaking is available. For CRA 4 / webpack 4 both paths are bundled,
    // but the `if` block never executes in demo mode or with incomplete config.
    const { initializeApp } = require('firebase/app');
    const { getAuth } = require('firebase/auth');

    app = initializeApp(FIREBASE_CONFIG);
    auth = getAuth(app);
}

export { app, auth };
